module.exports = __webpack_public_path__ + "static/media/Spkr440.47a968cc.wav";